var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"main"},[_c('div',{staticClass:"h-100"}),_c('div',{staticClass:"row align-items-center justify-content-center"},[_c('div',{staticClass:"col-lg-4 col-12"},[_c('Lottie',{ref:"lottieFunc",attrs:{"path":'animate/loading-168.json',"title":'',"info":'',"show":_vm.showLottie}})],1)]),_c('Common',{ref:"commonFunc"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }